import * as types from './actionTypes';
import * as permissions from '../common/userPermissions';

const initialSelected = {
	user: {},
	permissions: []
};

const initialState = {
	list: [],
	valid: false,					
	selected: initialSelected
};

export default function reducer(state = initialState, action = {}) {
	switch(action.type) {
		case types.ALL_USERS_RECEIVED: {
			return {
				...state,
				list: action.payload.users,
				valid: true
			};
		}
		case types.SELECT_USER: {
			return {
				...state,
				selected: {
					user: action.payload.selectedUser,
					permissions: action.payload.selectedUser.subscriptions
				}
			};
		}
		case types.DESELECT_USER: {
			return {
				...state,
				selected: initialSelected
			};
		}
		case types.TOGGLE_USER_PERMISSION: {
			// We use JSON.parse to get a deep copy, as with redux we can't mutate the state directly.
			let subscriptions = JSON.parse(JSON.stringify(state.selected.permissions));
			let subscription = subscriptions.find((subscription) => {
				return subscription.id === action.payload.subscriptionId;
			});
			
			switch(action.payload.permissionType) {
				case permissions.ACCESS_CARE_SHEETS:
					subscription.permissions.accessCareSheets = !subscription.permissions.accessCareSheets;
					break;
				case permissions.ACCESS_LABELS:
					subscription.permissions.accessLabels = !subscription.permissions.accessLabels;
					break;
				case permissions.MANAGE_ARTICLES:
					subscription.permissions.manageArticles = !subscription.permissions.manageArticles;
					break;
				case permissions.MANAGE_LOGO:
					subscription.permissions.manageLogo = !subscription.permissions.manageLogo;
					break;
				case permissions.MANAGE_CARE_SHEET_ADS:
					subscription.permissions.manageCareSheetAds = !subscription.permissions.manageCareSheetAds;
					break;
			}
			return {
				...state,
				selected: {
					...state.selected,
					permissions: subscriptions
				}
			};
		}
		case types.INITIALIZE_PERMISSION_TABLE: {
			return {
				...state,
				selected: {
					...state.selected,
					permissions: action.payload.subscriptions
				}
			};
		}
		default:
			return state;
	}
}


/** WEBPACK FOOTER **
 ** ./src/modules/users/reducer.js
 **/